import React from 'react';
import PropTypes from 'prop-types';
import './Popup.css';

function PopupButton({ label, className, onClick = null, style = {}, cancelClick = () => {}, closeAuto = false }) {
  const overrideClick = () => {
    if (onClick) {
      onClick();
      if (closeAuto) { cancelClick() }
    } else {
      cancelClick();
    }
  }
  return <div className={`popupv2-button ${className}`} style={style} onClick={overrideClick}>{label}</div>
}

PopupButton.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  cancelClick: PropTypes.func
}

export default PopupButton;
